import { Directive, ElementRef, Input, OnChanges, Optional, Self, SimpleChanges } from '@angular/core';
import { Deferred } from '../../../../modules/tcm-core.module';
import { TranslationService } from '../../../../services/translation.service';
import { CountryDataService } from '../../../../services';
import { TextInputComponent } from '../../../../modules/tcm-form/controls/text-input/text-input.component';

@Directive({
    selector: '[state-label]',
    standalone: false
})
export class StateLabelDirective implements OnChanges {

    @Input() country: string;

    private _cancellationTokenDeferred: Deferred;

    constructor(
        private element: ElementRef, 
        @Optional() @Self() private host: TextInputComponent, 
        private translationService: TranslationService,
        private countryDataService: CountryDataService) {
        this._cancellationTokenDeferred = new Deferred();
    }

    async ngOnChanges(changes: SimpleChanges) {
        var label = "";

        if (this.country) {
            this.resolveProcessingRequest();

            label = await this.countryDataService.getCountryStateLabelAsync(this.country, this._cancellationTokenDeferred.promise());
        }

        if (!label) {
            label = this.translationService.translate(schema => schema.Common.SearchColumnsAndDetailsFields.State);
        }

        if (this.host) {
            this.host.label = label;
        }
        else {
            this.element.nativeElement.innerText = label;
        }
    }

    public ngOnDestroy(): void {
        this.resolveProcessingRequest();
    }

    private resolveProcessingRequest() {
      if (this._cancellationTokenDeferred) {
        this._cancellationTokenDeferred.resolve();
      }
  
      this._cancellationTokenDeferred = this._cancellationTokenDeferred.createDeferred();
    }
}

